<div class="row justify-content-center no-padding head-main  header-menu">


  <nav class="navbar navbar-expand-lg header-menu no-padding">
    <button (click)="MenuAction()" mat-flat-button color="primary" class="menu-toggle" aria-label="menu"
      style="height: 100%;position: absolute;left: 0px;border-radius: 0% 50px 50px 00% !important;">
      <mat-icon>menu</mat-icon>
      <span class="menuhead">{{ 'NAVBAR.MENU' | translate }}</span>
    </button>



    <a *ngIf="header_url === 'https://mam.clem.mobi/'" [href]="header_url" routerLinkActive="active" style="margin: auto;">
      <img [src]="img" class="imglogomam" alt="clem">
    </a>

    <a *ngIf="header_url !== 'https://mam.clem.mobi/'" [href]="header_url" routerLinkActive="active" style="margin: auto;">
      <img [src]="img" class="imglogo" alt="clem">
    </a>

    

    <div class="rightnavlang">

      <select class="translate" #langSelect (change)="translate.use(langSelect.value)">
        <option *ngFor="let lang of locales" [value]="lang.value" [selected]="lang.value === translate.currentLang">{{
          lang.label }}</option>
      </select>

    </div>


    <div class="rightnavstatus">

      <a *ngIf="isLogin() === false" class="statususer" routerLink="/connexion" style="cursor: pointer;">
        {{ 'NAVBAR.STATUSOFF' | translate }}
      </a>

      <a *ngIf="isLogin() === true" class="statususer">
        {{ 'NAVBAR.STATUSON' | translate }}
      </a>

    </div>

  </nav>


</div>